import React, { useState, useEffect } from "react";
import Rotator from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import LoadingIcon from "../../../../../Assets/Images/ButtonLoadingIcon.svg";
import axios from "axios";
import { Config } from "../../../../../Config";

const MaintainMode = (props) => {
  const [IsLoading, setIsLoading] = useState(false);
  const [Duration, setDuration] = useState();
  const [Id, setId] = useState(""); //used for API data in PUT method for updating the timeout duration
  const [IsResetting, setIsResetting] = useState(false);
  const [ResetIsDone, setResetIsDone] = useState(false);
  const [ResetBtnText, setResetBtnText] = useState("Restart");
  const [JPARecomRequested, setJPARecomRequested] = useState(false);
  const [CandidateRecomRequested, setCandidateRecomRequested] = useState(false);
  const [RecommendationIsDisabled, setRecommendationIsDisabled] =
    useState(false);
  const [CandidateRecomIsDisabled, setCandidateRecomIsDisabled] =
    useState(false);

  const disableSaveBtn = () => {
    props.SetHasUnsavedChanges(false);
    document.getElementById("save-btn").classList.add("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 0); // 1 means true, 0 means false
  };
  const enableSave = () => {
    document.getElementById("save-btn").classList.remove("disabled");
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
  };
  const validateEntries = () => {
    let ValueEntered = document.getElementById("minutes").value;
    if (ValueEntered.length === 0) {
      document.getElementById("minutes").classList.add("wrong-state");
      window.localStorage.setItem("HasUnsaveChanges", 1);
    } else if (parseInt(ValueEntered) <= 5 || parseInt(ValueEntered) >= 120) {
      document.getElementById("validation-text").style.color = "#ff7474";
      document.getElementById("minutes").classList.add("wrong-state");
    } else {
      setIsLoading(true);
      saveConfiguration();
    }
  };
  const saveConfiguration = () => {
    let Req = {
      method: "PUT",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/general-config/application-setting/session-timeout",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        id: Id,
        value: document.getElementById("minutes").value,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsLoading(false);
        disableSaveBtn();
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsLoading(false);
      });
  };
  const toggleResetApplications = () => {
    setIsResetting(true);
    resetPositionApplications();
  };
  const resetPositionApplications = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/application/clean-data",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        resetActivityApplications();
      })
      .catch((Err) => {
        console.log(Err);
        setIsResetting(false);
      });
  };
  const resetActivityApplications = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/application/clean-data",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        resetProjcetApplications();
      })
      .catch((Err) => {
        console.log(Err.response);
        setIsResetting(false);
      });
  };
  const resetProjcetApplications = () => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/application/clean-data",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsResetting(false);
        setResetIsDone(true);
        setResetBtnText("Done!");
        setTimeout(() => {
          setResetBtnText("Restart");
        }, 1000);
      })
      .catch((Err) => {
        console.log(Err);
        setIsResetting(false);
      });
  };

  const toggleJPARecommendation = () => {
    setJPARecomRequested(true);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/data-sync/ignite-ai-jpa",
      headers: {
        Authorization: "bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJPARecomRequested(false);
        setRecommendationIsDisabled(true);
        setTimeout(() => {
          setRecommendationIsDisabled(false);
        }, 900000); // 15 minutes
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const toggleCandidateRecommendation = () => {
    setCandidateRecomRequested(true);

    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/data-sync/ignite-ai-candidate",
      headers: {
        Authorization: "bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setCandidateRecomRequested(false);
        setCandidateRecomIsDisabled(true);
        setTimeout(() => {
          setCandidateRecomIsDisabled(false);
        }, 900000); // 15 minutes
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  return (
    <div className="main-content security-settings app-settings-form">
      <div className="user-management-form">
        <section className="form-header">
          <h1>Maintain Mode</h1>
          <div className="button-group">
            {IsLoading ? (
              <button
                onClick={() => null} //this button is disabled and won't act when loading is set to true
                id="save-btn"
                className="save no-action"
              >
                <img alt="" className="rotator" src={Rotator} />
              </button>
            ) : (
              <button
                onClick={() => validateEntries()}
                id="save-btn"
                className="save disabled"
              >
                Save
              </button>
            )}
          </div>
        </section>
        <section className="form-body single-field-form">
          <div className="row">
            <section className="reset-application">
              <p className="tip">Application process</p>
              {IsResetting ? (
                <span onClick={() => null} className="reset-btn">
                  <img alt="" src={LoadingIcon} className="rotator" />
                </span>
              ) : (
                <span
                  onClick={() => toggleResetApplications()}
                  className="reset-btn"
                >
                  {ResetBtnText}
                </span>
              )}
            </section>
          </div>
          <div className="row">
            <section className="reset-application">
              <p className="tip">Update recommendations</p>
              {JPARecomRequested ? (
                <span onClick={() => null} className="reset-btn">
                  <img alt="" src={LoadingIcon} className="rotator" />
                </span>
              ) : (
                <span
                  onClick={() => toggleJPARecommendation()}
                  className={
                    RecommendationIsDisabled
                      ? "reset-btn disabled"
                      : "reset-btn"
                  }
                >
                  JPA
                </span>
              )}
            </section>
          </div>
          <div className="row">
            <section className="reset-application">
              <p className="tip">Update recommendations</p>
              {CandidateRecomRequested ? (
                <span onClick={() => null} className="reset-btn">
                  <img alt="" src={LoadingIcon} className="rotator" />
                </span>
              ) : (
                <span
                  onClick={() => toggleCandidateRecommendation()}
                  className={
                    CandidateRecomIsDisabled
                      ? "reset-btn disabled"
                      : "reset-btn"
                  }
                >
                  Candidates
                </span>
              )}
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default MaintainMode;
